export const sidebarurl = {
    0: {
        icon: 'zmdi-home',
        url: 'dashboard',
        name: 'Dashboard',
        key: 'dashboard',
        child: false
    },
    1: {
        icon: 'zmdi-settings',
        name: 'Setting',
        key: 'pagesetting',
        childlength: 1,
        child: {
            0: {
                url: 'pagesetting',
                name: 'Page Setting'
            },
            1: {
                url: 'pagesetting/menusetting',
                name: 'Menu Setting'
            },
        }
    },
    2: {
        icon: 'zmdi-label',
        name: 'Rates',
        key: 'rate',
        child: {
            0: {
                url: 'rate/carloanrates',
                name: 'Car Loan',
            },
            1: {
                url: 'rate/homeloanrates',
                name: 'Home Loan'
            },
            2: {
                url: 'rate/personalloanrates',
                name: 'Personal Loan'
            }
        }
    },
    3: {
        icon: 'zmdi-alert-circle',
        name: 'Error Log',
        key: 'errorlog',
        child: {
            0: {
                url: 'errorlog/cronerrorlog',
                name: 'Cron Log'
            },
            1: {
                url: 'errorlog/databaseerrorlog',
                name: 'Database Log'
            },
            2: {
                url: 'errorlog/emailerrorlog',
                name: 'Email Log'
            }
        }
    },
    4: {
        icon: 'zmdi-circle',
        name: 'Constant',
        key: 'wishfinconstant',
        child: {
            0: {
                url: 'wishfinconstant',
                name: 'Wishfin Constant'
            }
        }
    },
    5: {
        icon: 'zmdi-circle',
        name: 'MIS',
        key: 'mis',
        child: {
            0: {
                url: 'mis/pl-campaign',
                name: 'PL Campaign'
            },
            1: {
                url: 'mis/hl-campaign',
                name: 'HL Campaign'
            },
            2: {
                url: 'mis/email-campaign',
                name: 'Email Campaign'
            },
            3: {
                url: 'mis/cc-campaign',
                name: 'CC Campaign'
            },
            4: {
                url: 'mis/cibil-autofetch',
                name: 'Cibil Autofetch'
            },
            5: {
                url: 'mis/cibil-analytics',
                name: 'Cibil Analytics'
            },
            6: {
                url: 'mis/credit-saison',
                name: 'Credit Saison'
            },
            7: {
                url: 'mis/home-credit',
                name: 'Home Credit'
            },
            8: {
                url: 'mis/hc-campaign',
                name: 'Leads Home Credit'
            },
            9: {
                url: 'mis/cs-campaign',
                name: 'Leads Credit Saison'
            },
            10: {
                url: 'mis/piramal',
                name: 'Leads Piramal'
            },
            11: {
                url: 'mis/bfl',
                name: 'BFL Leads'
            },
            12: {
                url: 'mis/mv',
                name: 'MV Marketplace'
            },
            13: {
                url: 'mis/tata-stpl',
                name: 'Tata Stpl'
            },
            14: {
                url: 'mis/hdfc-pl',
                name: 'HDFC PL'
            },
            15: {
                url: 'mis/cc-mis-app',
                name: 'CC MIS ANDROID'
            },
            16: {
                url: 'mis/idfc-first-bank',
                name: 'IDFC First Bank'
            },
            17: {
                url: 'mis/iifl',
                name: 'IIFL Bank'
            },
            18: {
                url: 'mis/pushengage-cibil-analytics',
                name: 'Pushengage Cibil Analytics'
            },
            19: {
                url: 'mis/cc-bank-mis-app',
                name: 'CC Bank MIS APP'
            },
            20: {
                url: 'mis/document-upload',
                name: 'Document Upload'
            },
            21: {
                url: 'mis/tata-documents',
                name: 'Tata Documents'
            },
            22: {
                url: 'mis/campaign-exclusive',
                name: 'Campain Exclusive'
            },
            23: {
                url: 'mis/cc-mis-web',
                name: 'CC MIS WEB'
            },
            24: {
                url: 'mis/lnt-leads',
                name: 'L&T Leads'
            },
            25: {
                url: 'mis/exclusive-cctracking',
                name: 'Exclusive CC Tracking'
            },
            26: {
                url: 'mis/vendor-cibil-analytics',
                name: 'Vendor Cibil Analytics'
            },
            27: {
                url: 'mis/ibl-analytics',
                name: 'IBL Analytics'
            },
            28: {
                url: 'mis/india-one',
                name: 'India One'
            },
            29: {
                url: 'mis/idfc-lap',
                name: 'Idfc Lap'
            },
            30: {
                url: 'mis/idfc-bl',
                name: 'Idfc BL'
            },
            31: {
                url: 'mis/yesbank-analytics',
                name: 'YesBank Analytics'
            },
            32: {
                url: 'mis/tata-bl',
                name: 'Tata BL'
            },
            33: {
                url: 'mis/lnt-campaigns',
                name: 'L&T Campaigns'
            },
            34: {
                url: 'mis/tata-digital-pl',
                name: 'Tata Digital PL'
            },
            35: {
                url: 'mis/sms-whatsapp',
                name: 'SMS/Whatsapp Template'
            },
            36: {
                url: 'mis/axis-lead',
                name: 'Axis Lead'
            },
            37 : {
                url : 'mis/liquiloans-pl',
                name : 'LiquiLoans Pl Analytics'
            },
            38 : {
                url : 'mis/ibl-cc',
                name : 'IBL CC'
            },
            39 : {
                url : 'mis/tata-pl-campaign-count',
                name : 'Tata PL Campaign'
            },
            40 : {
                url : 'mis/incred-lead',
                name : 'Incred Lead'
            },
            41 : {
                url : 'mis/early-salary-lead',
                name : 'Early Salary Lead'
            },
            42 : {
                url : 'mis/sbi-lead',
                name : 'SBI Lead'
            },
            43 : {
                url : 'mis/kreditbee-lead',
                name : 'Kreditbee Lead'
            },
            44 : {
                url : 'mis/kreditbee-campaign',
                name : 'Kreditbee Campaign'
            },
            45 : {
                url : 'mis/dmi-lead',
                name : 'DMI Lead'
            },
            46 : {
                url : 'mis/navi-lead',
                name : 'Navi Lead'
            },
            47 : {
                url : 'mis/mv-dedupe',
                name : 'MV Dedupe'
            },
            48 : {
                url : 'mis/mv-replica',
                name : 'MV Replica'
            },
            49 : {
                url : 'mis/mvadmin2-lead',
                name : 'MV Admin2'
            },
            50 : {
                url : 'mis/zype-pl-analytics',
                name : 'Zype Pl Analytics'
            },
            51 : {
                url : 'mis/indifi-lead',
                name : 'Indifi BL'
            },
            52 : {
                url : 'mis/campaign-pq',
                name : 'KreditBee Campaign PQ'
            },
            53 : {
                url : 'mis/mp-campaign-cibil-score-lead',
                name : 'MP Campaign Cibil Score Lead'
            },
            54 : {
                url : 'mis/mp-campaign-personal-loan-lead',
                name : 'MP Campaign PL Lead'
            },
            55 : {
                url : 'mis/campaign-kb-new-segment-lead',
                name : 'Campaign KB New Segment Lead'
            },
            56 : {
                url : 'mis/marketplace-pl-count',
                name : 'Market Place PL Count'
            },
            57 : {
                url : 'mis/marketplace-pl-lead',
                name : 'Market Place PL Lead'
            },
            58 : {
                url : 'mis/pl-bt-leads',
                name : 'PL BT Lead'
            }, 
            59 : {
                url : 'mis/cibil-wa-count',
                name : 'CIBIL WA Count'
            },
            60 :{
                url : 'mis/lendingkart-lead',
                name : 'Lending Kart'
            },
            61 :{
                url : 'mis/multiple-pl-count',
                name : 'Multiplel PL Count'
            },
            62 :{
                url : 'mis/offline-banks',
                name : 'Offline Banks'
            },
            63 :{
                url : 'mis/generic-lead',
                name : 'Generic Lead'
            },
            64 :{
                url : 'mis/online-leads',
                name : 'Online Banks Lead'
            },
            65 :{
                url : 'mis/cashe-lead',
                name : 'Cashe Lead'
            },
            66 :{
                url : 'mis/exclusive-cc-count',
                name : 'Exclusive CC Google Count'
            },
            67 :{
                url : 'mis/campaign-best-personal-loan-count',
                name : 'Campaign Best Personal Loan Count'
            },
            68 :{
                url : 'mis/overdraft-pl-count',
                name : 'Overdraft PL Count'
            },
            69 :{
                url : 'mis/credit-vidya-lead',
                name : 'Credit Vidya Lead'
            },
            70 :{
                url : 'mis/best-credit-card-count',
                name : 'Best Credit Card Count'
            },
            71:{
                url : 'mis/exclusive-cc-lead-detail',
                name : 'Exclusive CC Lead Detail'
            },
            72:{
                url : 'mis/tata-resume-journey',
                name : 'Tata Resume Journey'
            },
            73:{
                url : 'mis/niro-lead',
                name : 'Niro Lead'
            },
            74:{
                url : 'mis/cibil-count',
                name : 'Cibil Count'
            },
            75:{
                url : 'mis/ibl-lead-tracking',
                name : 'IBL Lead Tracking'
            },
            76:{
                url : 'mis/bajaj-od-count',
                name : 'Bajaj OD Count'
            },
            77:{
                url : 'mis/multiple-pl-lead-count',
                name : 'Multiple PL Lead Count'
            },
            78:{
                url : 'mis/android-pl-count',
                name : 'Android PL Count'
            },
            79:{
                url : 'mis/android-cibil-status-count',
                name : 'Android Cibil Status Count'
            },
            80:{
                url : 'mis/multiple-pl-lead',
                name : 'Multiple PL Lead'
            },
            81:{
                url : 'mis/abfl-lead',
                name : 'ABFL Lead'
            }
        }
    },
    6: {
        icon: 'zmdi-search-in-file',
        name: 'Career',
        key: 'career',
        child: {
            0: {
                url: 'career/jobdetail',
                name: 'Job Detail'
            },
            1: {
                url: 'career/applicantdetail',
                name: 'Applicant Detail'
            },
            2: {
                url: 'career/applicant-detail-direct-apply',
                name: 'Applicant Detail Direct Apply'
            }
        }
    },
    7: {
        icon: 'zmdi-balance-wallet',
        url: 'fixeddeposit',
        name: 'Fixed Deposit',
        key: 'fixeddeposit',
        child: false
    },
    8: {
        icon: 'zmdi-chart',
        url: 'cibilstats',
        name: 'Cibil Stats',
        key: 'cibilstats',
        child: false
    },
    9: {
        icon: 'zmdi-chart',
        url: 'ftbannerstats',
        name: 'FT Banner Stats',
        key: 'ftbannerstats',
        child: false
    },
    _10: {
        icon: 'zmdi-chart',
        url: 'banksurl',
        name: 'Banks',
        key: 'banksurl',
        child: false
    },
    _11: {
        icon: 'zmdi-delete',
        url: 'cache/cache-remove',
        name: 'Cache',
        key: 'cache-remove',
        child: false
    },
    _12: {
        icon: 'zmdi-chart',
        name: 'Invest MF Online',
        key: 'investmfonline',
        child: {
            0: {
                url: 'investmfonline/leads',
                name: 'Leads'
            }
        }
    },
    13: {
        icon: 'zmdi-circle',
        name: 'Referral',
        key: 'cibilreferral',
        child: {
            0: {
                url: 'cibilreferral/referal-analytics',
                name: 'Referal Analytics'
            },
            1: {
                url: 'cibilreferral',
                name: 'Referral Leads'
            },
            2: {
                url: 'cibilreferral/payment-process',
                name: 'Payment Process'
            }
            
        }
    },
    14: {
        icon: 'zmdi-chart',
        name: 'User',
        key: 'user-disabled',
        child: {
            0: {
                url: 'user/user-disabled',
                name: 'Promotional Block'
            },
            1: {
                url: 'user/permanent-block-user',
                name: 'Permanent Block'
            }
        }
    },
    15: {
        icon: 'zmdi-notifications-active',
        name: 'Notification',
        key: 'notification',
        child: {
            0: {
                url: 'notification/android-notification',
                name: 'Android Notification'
            }
        }
    },    
};
